import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonChip,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonLabel,
  IonMenuToggle,
  IonPage,
  IonRow,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { Link } from "react-router-dom";
import { arrowForward, documentText, menu } from "ionicons/icons";
import { CategorieLinks } from "../../components/CategorieLinks/CategorieLinks";
import Seo from "../../common/Seo";
import { usePaymentConfig } from "../Payment/usePaymentConfig";

interface DocLinkProps {
  link: string;
}

const DocLink: React.FC<DocLinkProps> = ({ children, link }) => (
  <div>
    <a
      href={`https://bojenjepobrojevima.rs/assets/docs/${link}`}
      style={{
        textDecoration: "none",
        color: "var(--ion-color-dark)",
      }}
      target="_blank"
      rel="noreferrer"
    >
      {children}
    </a>
  </div>
);

const AboutUs = () => {
  const { showBrands, cardLive } = usePaymentConfig();
  return (
    <IonPage id="start-page">
      <Seo
        title="O nama"
        description="Bojenje po brojevima nije samo hobi – to je mali ritual opuštanja. Saznajte više o nama, načinu poručivanja, plaćanju i rokovima isporuke u Srbiji i BiH."
        path="/o-nama"
      />
      <IonHeader no-border>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonMenuToggle>
              <IonIcon icon={menu} style={{ fontSize: 28 }} />
            </IonMenuToggle>
          </IonButtons>
          <IonTitle>Bojenje po brojevima</IonTitle>
          <IonButtons slot="end">
            <Link to={{ pathname: "/slike" }}>
              <IonButton color="dark">Motivi</IonButton>
            </Link>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <h1 className="sr-only">O nama — Bojenje po brojevima</h1>
        <IonGrid className="ion-no-padding">
          <IonRow>
            <IonCol size="12" sizeMd="6" offsetMd="3">
              <img
                src="assets/BPB_logo.png"
                alt="Bojenje po brojevima logo"
                className="slide-image"
              />
            </IonCol>
          </IonRow>
        </IonGrid>

        <IonGrid className="ion-no-padding">
          <IonRow>
            <IonCol
              size="12"
              sizeMd="6"
              offsetMd="3"
              sizeSm="8"
              offsetSm="2"
              sizeLg="8"
              offsetLg="2"
              sizeXl="6"
              offsetXl="4"
            >
              <IonCard>
                <IonCardHeader
                  className="b f15 ion-text-center"
                  style={{ color: "var(--ion-color-dark)" }}
                >
                  O nama
                </IonCardHeader>
                <IonCardContent>
                  <div
                    className="ion-text-justify"
                    style={{ paddingTop: "10px" }}
                  >
                    <IonText>
                      Bojenje po brojevima nije samo hobi – to je mali ritual
                      opuštanja. Zasnovano na tehnici usmeravanja pažnje, pomaže
                      vam da se fokusirate, umirite misli i lakše upravljate
                      emocijama. Upravo zato je art terapija danas toliko
                      popularna – jer donosi osećaj unutrašnjeg mira, balansa i
                      zadovoljstva.
                      <br />
                      <br />
                      Na našem sajtu možete jednostavno poručiti željeni motiv ili
                      ga rezervisati ukoliko trenutno nije dostupan. Naš tim će
                      vas brzo kontaktirati radi potvrde porudžbine i informisati
                      o tačnom roku isporuke.
                      <br />
                      <br />
                      {cardLive ? (
                        <>
                          Porudžbinu možete platiti pouzećem ili platnom karticom
                          (Visa, Mastercard, Maestro, DinaCard, American Express)
                          preko zaštićene stranice banke.
                        </>
                      ) : (
                        <>
                          Plaćanje se ne vrši online – porudžbinu plaćate kuriru
                          prilikom preuzimanja paketa.
                        </>
                      )}{" "}
                      Motivi koji su na stanju stižu
                      na vašu adresu u roku od 2–4 radna dana u Srbiji, odnosno
                      3–6 radnih dana u Bosni i Hercegovini.
                      <br />
                      <br />
                      Uživajte u stvaranju, korak po korak 🎨
                    </IonText>
                  </div>
                  <br />

                  <DocLink link="Obavestenje-o-politici-privatnosti.pdf">
                    <IonChip>
                      <IonIcon icon={documentText} color="dark" />
                      <IonLabel style={{ textDecoration: "none" }}>
                        Obaveštenje o politici privatnosti
                      </IonLabel>
                    </IonChip>
                  </DocLink>
                  <DocLink link="Pravilnik-o-kataloškom-poručivanju-proizvoda.pdf">
                    <IonChip style={{ height: "auto" }}>
                      <IonIcon icon={documentText} color="dark" />
                      <IonLabel>
                        Pravilnik o kataloškom poručivanju proizvoda
                      </IonLabel>
                    </IonChip>
                  </DocLink>
                  <DocLink link="Pravilnik-o-zaštiti-podataka-ličnosti.pdf">
                    <IonChip>
                      <IonIcon icon={documentText} color="dark" />
                      <IonLabel>Pravilnik o zaštiti podataka ličnosti</IonLabel>
                    </IonChip>
                  </DocLink>
                  <DocLink link="Pravo-na-odustajanje.pdf">
                    <IonChip>
                      <IonIcon icon={documentText} color="dark" />
                      <IonLabel>Pravo na odustajanje</IonLabel>
                    </IonChip>
                  </DocLink>
                  <DocLink link="Reklamacioni-list.pdf">
                    <IonChip>
                      <IonIcon icon={documentText} color="dark" />
                      <IonLabel>Reklamacioni list</IonLabel>
                    </IonChip>
                  </DocLink>
                  {showBrands && (
                    <div>
                      <Link
                        to={{ pathname: "/uslovi" }}
                        style={{ textDecoration: "none", color: "var(--ion-color-dark)" }}
                      >
                        <IonChip>
                          <IonIcon icon={documentText} color="dark" />
                          <IonLabel>Uslovi kupovine i plaćanja</IonLabel>
                        </IonChip>
                      </Link>
                    </div>
                  )}
                </IonCardContent>
              </IonCard>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol>
              <CategorieLinks />
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-center">
              <Link to={{ pathname: `/paket` }}>
                <IonButton fill="clear" style={{ marginBottom: 10 }}>
                  Sadržaj seta
                  <IonIcon slot="end" icon={arrowForward} />
                </IonButton>
              </Link>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default AboutUs;
